import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { EvidencePage } from './components/Evidence';
import { isEvidencePath } from './lib/route';
import './styles.css';

const queryClient = new QueryClient();

const root = document.getElementById('root');
if (!root) throw new Error('no #root element');

const evidence = isEvidencePath(location.pathname);
if (evidence) document.title = 'Bellguard: reviewer evidence';

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {evidence ? <EvidencePage /> : <App />}
    </QueryClientProvider>
  </StrictMode>,
);
